import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface StatBoxProps {
  label: string;
  value: string | number;
  valueColor?: string;
  bg?: string;
  minWidth?: number | string;
  align?: 'left' | 'right' | 'center';
}

const StatBox: React.FC<StatBoxProps> = ({
  label,
  value,
  valueColor = '#1E293B',
  bg = '#F8FAFC',
  minWidth,
  align = 'left',
}) => (
  <Box sx={{
    px: 2, py: 1.25,
    borderRadius: 2,
    backgroundColor: bg,
    border: '1px solid #E2EAF2',
    minWidth: minWidth ?? 'auto',
    textAlign: align,
  }}>
    <Typography sx={{ fontFamily: 'Inter', fontSize: '10px', color: '#8A98A8', lineHeight: 1.2 }}>
      {label}
    </Typography>
    <Typography sx={{ fontFamily: 'Inter', fontSize: '15px', fontWeight: 700, color: valueColor, lineHeight: 1.4 }}>
      {value}
    </Typography>
  </Box>
);

export default StatBox;
